interface action {
    type: string,
    payload: object,
}

const granularSalesStatsReducer = (state = {}, action: action) => {
    switch(action.type) {
        case 'ADD_GRANULAR_SALES_STATS':
            return {
                ...state,
                ...action.payload
            }
        default:
            return state;
    }
}

export default granularSalesStatsReducer;